export default class BaseDate {
  get milliseconds() {
    return this.date.valueOf();
  }

  get day() {
    return this.date.date();
  }

  get monthName() {
    return this.date.format("MMMM")
  }

  get yearName() {
    return this.date.format("YYYY")
  }

  get month() {
    return this.date.month();
  }

  get monthMeta() {
    const firstDay = this.date.clone().startOf("month")
    const lastDay = this.date.clone().endOf("month")
    return {
      days: lastDay.date(), startingDay: firstDay.day()
    }
  }

  clearTime() {
    this.date.hour(0).minute(0).second(0).millisecond(0)
    return this
  }

  setMonthDay(day) {
    this.date.date(day)
    return this
  }

  add(num, t) {
    this.date.add(num, t)
    return this
  }

  subtract(num, t) {
    this.date.subtract(num, t)
    return this
  }
}
